import React, { useEffect, useState } from "react";
import { Row, Col, Typography, Space, Spin, message } from "antd";
import RTATable from "./components/RTATable";
import SectionHeader from "../../molecules/SectionHeader";
import { useDispatch } from "react-redux";
import axios from "axios";
import { portalService } from "../../../configs/constants";
import { clearReduxData, setDriver } from "./duck/driverSlice";
import { downloadCsvLocal } from "../../../utils/helper";

export default function RtaPermit() {
  const [loader, setLoader] = useState(false);
  const [total, setTotal] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearReduxData());
    callApi();
  }, []);

  const parseDriverData = (data: any[]) => {
    return data.map((itemItt, key) => {
      const item = itemItt?.driver || {};
      return {
        ...item,
        key: item.employeeId || "-",
        createdAt: itemItt?.createdAt || "-",
        documentId: itemItt?.documentId || "-",
        driverConsentRequired: itemItt?.driverConsentRequired || "-",
        driverId: itemItt?.driverId || "-",
        employeeId: itemItt?.employeeId || "-",
        id: itemItt._id || "-",
        fusionId: itemItt.employeeId || "-",
        fullName: item.driverName || "-",
        nationality: item.nationality || "-",
        rtaPermitNo: item.rtaPermitNumber || "-",
        permitExpiryDate: item.rtaPermitExpiryDate || "-",
        trafficCode: item.trafficFileNumber || "-",
        dob: item.dateOfBirth || "-",
        mobileNo: item.mobileNumber || "-",
        eidNo: item.emiratesId || "-",
        eidExpiryDate: item.emiratesIdExpiryDate || "-",
        drivingLicenseNo: item.driverLicenseNumber || "-",
        dlExpiryDate: item.driverLicenseExpiryDate || "-",
        approved: itemItt.approved || false,
        _id: itemItt._id || "-",
      };
    });
  };

  const callApi = async () => {
    setLoader(true);

    try {
      const payload = {
        filter: {
          approved: false,
        },
      };

      const response = await axios.post(
        `${portalService}/user/get-driver-document-renewal-requests`,
        payload
      );

      const data = response?.data || [];
      setTotal(data?.length || 0);

      if (data.length > 0) {
        const parsedData = parseDriverData(data);

        dispatch(setDriver({ parsedData }));
      }
    } catch (error) {
      message.error("Failed to load templates.");
    } finally {
      setLoader(false);
    }
  };

  const downloadCsv = async () => {
    try {
      const csvUrl = `${portalService}/user/download-document-renewal-report`;
      const response = await axios.get(csvUrl);
      downloadCsvLocal(response.data, "rta_permit_report.csv");
      message.success("Report downloaded successfully.");
    } catch (error) {
      message.error("Failed to download report.");
    }
  };

  return (
    <>
      <Row gutter={24}>
        <Col span={24}>
          <SectionHeader
            heading="RTA Permit"
            noBorder={true}
            searchName="Category"
            justifiedItems={true}
            justifyEnd={true}
            importAction={total > 0 ? downloadCsv : null}
          />
        </Col>
        <Col span={24}>
          <Space size="middle" direction="horizontal">
            <Typography.Title level={5} style={{ margin: 0 }}>
              RTA Permit Renewal Requests
            </Typography.Title>
            {loader && <Spin />}
          </Space>
        </Col>
        <Col span={24}>
          <RTATable callApi={callApi} total={total} loading={loader} />
        </Col>
      </Row>

      <br />
    </>
  );
}
